<div class="navigation-control">
  <button
    (click)="toggleMapControl()"
    matTooltip="Couches"
    class="layers-button"
    [class.button_active]="$isOpenControl()">
    <mat-icon>layers</mat-icon>
  </button>

  @if (!$isMobile()) {
    <button
      (click)="toggleFullScreen()"
      [matTooltip]="'COMMON.FULLSCREEN' | translate"
      class="full-screen-button"
      [class.button_active]="!layoutService.hasOpenedLeftPanel()">
      <mat-icon>fullscreen</mat-icon>
    </button>
  }

  @if (!router.routerState.snapshot.url.startsWith('/home/map')) {
    <button
      (click)="toggleTrackingDevices()"
      [matTooltip]="'MAP.TRACK' | translate"
      class="track-button"
      [class.button_active]="mapService.$devicesTracking()">
      <mat-icon>radar</mat-icon>
    </button>
  }
</div>

@if ($isOpenControl()) {
  <div class="container-control-panel">
    <div class="container-row">
      <p class="title-part">{{ 'MAP.TOOLS' | translate }}</p>
      <div class="container-items">
        <button
          [matTooltip]="'MAP.MYPOSITION' | translate"
          [class.button_active]="mapService.positionOn"
          (click)="getMyPosition()">
          <mat-icon>my_location</mat-icon>
        </button>
        @if (!routingService.$isMobile() && !routingService.getFormMode()) {
          <button
            [matTooltip]="
              $isMeasuring() && $distance() ? ('COMMON.RESET' | translate) : ('MAP.MEASURE' | translate)
            "
            [class.button_active]="$isMeasuring()"
            (click)="$isMeasuring() && $distance() ? cleanMeasure() : mapService.openMapMeasure()">
            <mat-icon>
              {{ $isMeasuring() && $distance() ? 'refresh' : 'straighten' }}
            </mat-icon>
          </button>
        }
      </div>
    </div>
    <div class="container-row">
      <p class="title-part">{{ 'MAP.BASEMAP' | translate }}</p>
      <div class="container-items">
        <button
          matTooltip="Streets"
          [class.button-img_active]="mapService.baseLayer === 'map'"
          (click)="setBaseMap('map')">
          <img src="assets/map/streets.png" alt="Street basemap" />
        </button>
        <button
          matTooltip="Satellite"
          [class.button-img_active]="mapService.baseLayer === 'satellite'"
          (click)="setBaseMap('satellite')">
          <img src="assets/map/satellite.png" alt="Satellite basemap" />
        </button>
        <button
          matTooltip="Dark"
          [class.button-img_active]="mapService.baseLayer === 'dark'"
          (click)="setBaseMap('dark')">
          <img src="assets/map/dark.png" alt="Dark basemap" />
        </button>
        <button
          matTooltip="Light"
          [class.button-img_active]="mapService.baseLayer === 'light'"
          (click)="setBaseMap('light')">
          <img src="assets/map/light.png" alt="Light basemap" />
        </button>
        <button
          matTooltip="OSM"
          [class.button-img_active]="mapService.baseLayer === 'osm'"
          (click)="setBaseMap('osm')">
          <img src="assets/map/osm.png" alt="OSM basemap" />
        </button>
      </div>
    </div>
    <div class="container-row">
      <p class="title-part">Options</p>
      <div class="container-items">
        <button
          matTooltip="3D"
          [class.button_active]="mapService.threeDOn"
          (click)="mapService.set3dStyleMapbox()">
          <mat-icon>3d_rotation</mat-icon>
        </button>
        <button
          [matTooltip]="$account().traffic ? ('MAP.TRAFFIC' | translate) : ('MAP.TRAFFICOPTION' | translate)"
          [class.button_active]="mapService.traficOn"
          [class.disabled]="!$account().traffic"
          (click)="mapService.setTrafic(true)">
          <mat-icon>traffic</mat-icon>
        </button>
        @if ($account().isSubsEco && startsWithHistoryRoute()) {
          <button
            [matTooltip]="'TRIP.ECODRIVING' | translate"
            [class.button_active]="$isDisplayEcoEvent()"
            (click)="toggleEcoEventOnMap()">
            <mat-icon>priority_high</mat-icon>
          </button>
        }
      </div>
    </div>
    <!-- Commented waiting approbation of clusters... -->
    <!-- @if ($isNotDisplayDevices()) {
      <div class="container-row">
        <p class="title-part">Grappe</p>
        <div class="container-items">
          <button
            id="inactive"
            [matTooltip]="'Inactif'"
            [class.button_active]="mapService.clusterMode === 'inactive'"
            (click)="toggleClustersMode($event)">
            <mat-icon>not_interested</mat-icon>
          </button>
          <button
            id="circle"
            [matTooltip]="'Cercle'"
            [class.button_active]="mapService.clusterMode === 'circle'"
            (click)="toggleClustersMode($event)">
            <mat-icon>blur_circular</mat-icon>
          </button>
          <button
            id="polygon"
            [matTooltip]="'Polygone'"
            [class.button_active]="mapService.clusterMode === 'polygon'"
            (click)="toggleClustersMode($event)">
            <mat-icon>polyline</mat-icon>
          </button>
        </div>
      </div>
    } -->
    <div class="container-row">
      <p class="title-part">{{ 'MAP.LABEL' | translate }}</p>
      <div class="container-items">
        <button
          [matTooltip]="'MAP.REGISTRATION' | translate"
          [class.button_active]="mapService.deviceLabel.reg"
          [class.disabled]="!mapService.deviceLabel.driver"
          (click)="mapService.deviceLabel.driver ? switchDeviceLabel('registration') : ''">
          <mat-icon>pin</mat-icon>
        </button>
        <button
          [matTooltip]="'MAP.DRIVER' | translate"
          [class.button_active]="mapService.deviceLabel.driver"
          [class.disabled]="!mapService.deviceLabel.reg"
          (click)="mapService.deviceLabel.reg ? switchDeviceLabel('driver') : ''">
          <mat-icon>record_voice_over</mat-icon>
        </button>
      </div>
    </div>
    <div class="container-row">
      <p class="title-part">{{ 'POI.LANDMARKS' | translate }}</p>
      <div class="container-items">
        <button
          [matTooltip]="'MAP.NONE' | translate"
          [class.button_active]="$statePois() === 'none'"
          (click)="switchPoisMap('none')">
          <mat-icon>location_off</mat-icon>
        </button>
        <button
          [matTooltip]="'MAP.SMALL' | translate"
          [class.button_active]="$statePois() === 'poiLayer'"
          (click)="switchPoisMap('poiLayer')">
          <mat-icon style="width: 16px; height: 16px; font-size: 16px">location_on</mat-icon>
        </button>
        <button
          [matTooltip]="'MAP.BIG' | translate"
          [class.button_active]="$statePois() === 'poiLayerZoomed'"
          (click)="switchPoisMap('poiLayerZoomed')">
          <mat-icon style="width: 22px; height: 22px; font-size: 22px">location_on</mat-icon>
        </button>
        <button
          [matTooltip]="'MAP.AREA' | translate"
          [class.button_active]="$isDisplayZone()"
          (click)="toggleZoneOnMap()">
          <mat-icon>category</mat-icon>
        </button>
      </div>
    </div>

    @if (['/map'].includes(this.router.routerState.snapshot.url) || routingService.getFormMode(ALARMS)) {
      <div class="container-row">
        <p class="title-part">{{ 'MAP.TERRITORIES' | translate }}</p>
        <div class="container-items">
          <button (click)="displayTerritories()" [class.button_active]="!$selectedEntity()">
            <mat-icon>not_interested</mat-icon>
          </button>
          <button
            matTooltip="France"
            (click)="displayTerritories(EntityType.Country)"
            [class.button_active]="$selectedEntity() === EntityType.Country">
            FR
          </button>
          <button
            [matTooltip]="'MAP.REG' | translate"
            (click)="displayTerritories(EntityType.Region)"
            [class.button_active]="$selectedEntity() === EntityType.Region">
            R
          </button>
          <button
            [matTooltip]="'MAP.DEP' | translate"
            (click)="displayTerritories(EntityType.Department)"
            [class.button_active]="$selectedEntity() === EntityType.Department">
            D
          </button>
        </div>
      </div>
    }
  </div>
}
